/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import CreateModal from '../../CreateModal'
import { useUserInfo } from 'context/user'
import { useNavigate } from 'react-router-dom'

export default function DataTableData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  const [apps, setApps] = useState([])
  const [loader, setLoader] = useState(true)

  const [user] = useUserInfo()

  const navigate = useNavigate()

  const filter_partner = list?.filter((row) => row.app === user.app_id)

  const getAppTypes = async () => {
    const { response } = await AppService.partner.get({
      toaster: false,
    })
    if (response) {
      setList(response.data)
    } else {
      setList([])
    }
    setLoader(false)
  }
  const getApps = async () => {
    const { response, error } = await AppService.app.superadmin_apps()

    if (response) {
      setApps(response?.data)
    }
  }

  const onLoad = () => {
    getApps()
    getAppTypes()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.partner.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])

  const render_data = user.roles.some((role) => role === 'client') ? filter_partner : list

  return {
    loader: loader,
    apps: apps,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        { Header: 'description', accessor: 'description' },
        { Header: 'website', accessor: 'website' },
        { Header: 'video', accessor: 'video' },
        { Header: 'image', accessor: 'image' },
        { Header: 'app', accessor: 'app' },

        { Header: 'Action', accessor: 'action' },
      ],
      rows: render_data.map((data) => ({
        name: data.name ? `${data.name.substring(0, 20)}...` : '',
        description: data.description
          ? `${data.description.replace(/<[^>]+>/g, '').substring(0, 20)}...`
          : '',
        website: data.website ? `${data.website.substring(0, 20)}...` : '',
        video: data.video,
        image: data.image ? `${data.image.substring(0, 20)}...` : '',
        app: data.app ? data.app : '',

        action: (
          <>
            <MDBox>
              <EditModal data={data} handleRefresh={onLoad} apps={apps} />
              <MDButton
                variant="contained"
                color="warning"
                size="small"
                sx={{ marginLeft: 2 }}
                onClick={() => navigate(`./${data._id}`)}
              >
                View
              </MDButton>
              <MDButton
                variant="contained"
                color="error"
                size="small"
                sx={{ marginLeft: 2 }}
                onClick={() => handleDelete(data._id)}
              >
                Delete
              </MDButton>
            </MDBox>
          </>
        ),
      })),
    },
  }
}
